const HELP_CENTER_BASE = 'https://help.shipstation.com/hc';
const DEFAULT_LOCALE_PATH = 'en-us';

const LOCALE_PATH_BY_LANGUAGE = {
  de: 'de',
  fr: 'fr',
  es: 'es-us',
};

class HelpCenterServiceClass {
  getHelpCenterUrl(supportCountry = 'US') {
    const supportCountryToHelpCenterUrl = {
      GB: `${HELP_CENTER_BASE}/en-gb`,
      CA: `${HELP_CENTER_BASE}/en-ca`,
      AU: `${HELP_CENTER_BASE}/en-au`,
      FR: `${HELP_CENTER_BASE}/fr-fr`,
      DE: `${HELP_CENTER_BASE}/de`,
    };
    const helpCenterURl = supportCountryToHelpCenterUrl[supportCountry] || `${HELP_CENTER_BASE}/${DEFAULT_LOCALE_PATH}`;

    if (supportCountry === 'NZ') {
      return supportCountryToHelpCenterUrl.AU;
    }
    return helpCenterURl;
  }

  /**
   * Returns the help center URL for a given locale code (e.g. 'en', 'fr-CA', 'de').
   * Only the language part of the locale is considered; only sites that actually
   * exist are mapped — anything unrecognized falls back to en-us.
   * @param {string | null | undefined} locale
   * @returns {string}
   */
  getHelpCenterUrlByLocale(locale) {
    const language = (locale || '').split('-')[0].toLowerCase();
    const localePath = LOCALE_PATH_BY_LANGUAGE[language] || DEFAULT_LOCALE_PATH;
    return `${HELP_CENTER_BASE}/${localePath}`;
  }

  getSignInRedirectUrl(redirectTo) {
    return `support/signin?redirectTo=${encodeURIComponent(redirectTo)}`;
  }

  getMainSupportUrl(sellerHomeCountry) {
    return this.getSignInRedirectUrl(this.getHelpCenterUrl(sellerHomeCountry));
  }

  getSupportCasesUrl() {
    return this.getSignInRedirectUrl('https://help.shipstation.com/hc/en-us/requests');
  }
}

export const HelpCenterService = new HelpCenterServiceClass();
